






































import { Vue, Component, Prop } from 'vue-property-decorator';
import ChatFab from '@signing-page/chat/components/ChatFab.vue';
import ChatWindow from '@signing-page/chat/components/ChatWindow.vue';
import ChatActions from '@/chat/components/ChatActions.vue';
import ChatHeader from '@signing-page/chat/components/ChatHeader.vue';
import ChatContent from '@signing-page/chat/components/ChatContent.vue';
import ChatSystemMessage from '@signing-page/chat/components/ChatSystemMessage.vue';

import { IComment } from '@signing-page/chat/types/comment';
import { IUser } from '@/types/User';
import { IRecipient } from '@/types/Recipient';
import { ITheme } from '@signing-page/entity/types/theme';

@Component({
  components: {
    ChatFab,
    ChatWindow,
    ChatActions,
    ChatHeader,
    ChatContent,
    ChatSystemMessage,
  },
})
export default class Chat extends Vue {
  @Prop() me!: string;
  @Prop() user!: IUser;
  @Prop() comments!: IComment[];
  @Prop() recipients!: IRecipient[];
  @Prop() isOpen: boolean;
  @Prop() isPreview: boolean;
  @Prop() newCommentsCount: number;
  @Prop() theme?: ITheme;
  @Prop() systemMessageOpen: boolean;

  emojisEnabled = true;

  handleSystemMessageClose() {
    this.$emit('closeSystemMessage');
  }

  public toggle(): void {
    this.$emit('toggleChat', !this.isOpen);
  }

  public handleSend(text: string): void {
    this.$emit('send', text);
  }
}
